var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',[_vm._v(" mounted ")]),_vm._l((_vm.listPosts),function(item,index){return _c('div',{key:index},[_vm._v(" "+_vm._s(_vm.$trdb(item.name))+" ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }